import { render, staticRenderFns } from "./New.vue?vue&type=template&id=d17491a4&scoped=true&lang=pug&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.scss?vue&type=style&index=0&id=d17491a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17491a4",
  null
  
)

export default component.exports